import { utils } from '@inter-ikea-storagetwo/boaxel';
const calculateOptimalMountingRails = utils.calculateOptimalMountingRails;
export { calculateOptimalMountingRails };
//# sourceMappingURL=mountingRailOptimization.js.map